import classNames from 'classnames';
import { Button, ButtonSize, ButtonType } from '@nx-frontend/shared/ui/button';
import { Icon, IconsMap } from '@nx-frontend/shared/ui/icon';

interface AgentCardProps {
  isSelected: boolean;
  title: string;
  description?: string;
  onChange?: () => void;
  onEditClick?: () => void;
}

export const AgentCard: React.FC<AgentCardProps> = ({ title, description, isSelected, onChange, onEditClick }) => {
  return (
    <div
      className={classNames('flex flex-col gap-3 border rounded-lg py-3 px-4 cursor-pointer', {
        'border-neutral-200': !isSelected,
        'border-teal-500': isSelected,
      })}
      onClick={() => onChange?.()}
    >
      <div className="flex gap-3">
        <div>
          <div className="w-10 h-10 flex items-center justify-center rounded bg-cyan-100">
            <Icon icon={IconsMap.MAIL} className="w-5 h-5 text-teal-500" />
          </div>
        </div>

        <div className="font-bold line-clamp-2">{title}</div>
      </div>
      {description && <div className="text-neutral-500">{description}</div>}
      {onEditClick && (
        <Button type={ButtonType.STROKED} size={ButtonSize.MD} onClick={onEditClick}>
          Edit AI Agent
        </Button>
      )}
    </div>
  );
};
